// extracted by mini-css-extract-plugin
export default {"sirBorderRadiusM":"5px","sirGray":"#e3e3e3","a11yInput":"A11yInput_a11yInput__NKR71"};